import { render, staticRenderFns } from "./PopupConfirmacao.vue?vue&type=template&id=7e49d157&scoped=true"
import script from "./PopupConfirmacao.vue?vue&type=script&lang=js"
export * from "./PopupConfirmacao.vue?vue&type=script&lang=js"
import style0 from "./PopupConfirmacao.vue?vue&type=style&index=0&id=7e49d157&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e49d157",
  null
  
)

export default component.exports